import { useParams } from "react-router-dom";

import { useGetService } from "../../api/queries/useGetService";

import OwnedProgram from "./OwnedProgram";
import { UnBoughtProgram, UnBoughtProgramLoader } from "./UnBoughtProgram";

const ProgramPage = () => {
  const { serviceId } = useParams();
  const { data: service, isLoading: isServiceLoading } = useGetService(Number(serviceId));

  if (isServiceLoading || !service) return <UnBoughtProgramLoader />;

  const canRequestService = service.canRequest;

  if (!canRequestService) return <OwnedProgram service={service} />;
  return <UnBoughtProgram service={service} />;
};

export default ProgramPage;
